<div class="disclaimer">
  <span [innerHTML]="'company.support-devices.disclaimer' | translate"></span>
</div>
<div class="vox-table company-support-devices">
  <table>
    <thead>
      <tr>
        <td translate>company.support-devices.table.user</td>
        <td translate>company.support-devices.table.username</td>
        <td translate>company.support-devices.table.password</td>
        <td translate>company.support-devices.table.actions</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <ng-container *ngFor="let d of devices; let i = index;">
        <tr *ngIf="d._isLoading" class="data-row">
          <td colspan="4">
            <ngx-skeleton-loader></ngx-skeleton-loader>
          </td>
        </tr>
        <tr *ngIf="!d._isLoading" class="data-row">
          <td>{{d.first_name}} {{d.last_name}} ({{d.extension}})</td>
          <td class="username">
            <span *ngIf="!d.username">N.A.</span>
            <div *ngIf="d.username">
              <span>{{d.username}}</span>
              <button class="vox-btn vox-btn__copy btn-info" (click)="onCopy(d.username, 'username')" translate><i
                  class="fa fa-clone" aria-hidden="true"></i></button>
            </div>
          </td>
          <td class="password">
            <span *ngIf="!d.password">N.A.</span>
            <div *ngIf="d.password">
              <span>{{d.password}}</span>
              <button class="vox-btn vox-btn__copy btn-info" (click)="onCopy(d.password, 'password')" translate><i
                  class="fa fa-clone" aria-hidden="true"></i></button>
            </div>
          </td>
          <td class="actions">
            <button *ngIf="!d.username && !d.password" class="vox-btn btn btn-success" [disabled]="company.readOnly"
              (click)="onCreateDevice(d, i)" translate>company.support-devices.table.create</button>
            <button *ngIf="d.username && d.password" class="vox-btn btn btn-danger" [disabled]="company.readOnly"
              (click)="onDeleteDevice(d, i)" translate>company.support-devices.table.delete</button>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of [1,2,3,4]">
        <td colspan="4">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && devices.length === 0">
      <tr>
        <td colspan="4" translate>company.support-devices.table.empty</td>
      </tr>
    </tbody>

  </table>
</div>